
export const PARTNERS = {
  HOME_DEPOT: "homedepot",
  JACK_RABBIT: "jackrabbit",
  BST: "BST",
  RUG_DOCTOR: "RugDoctor",
};

export const PARTNERS_NAMES = {
  "jackrabbit": "Jack Rabbit",
  "homedepot": "Home Depot"
}

export const QUERY_PARAMS = {
  NON_SKIPTI_INVENTORY: "nonSkiptiInventory",
  STORE_ID: "storeId",
  CLIENT: "client",
  ZIP: "zip",
  ENTRY_FLOW: "entry"
};
